import * as React from 'react';
import { Theme, StyleRules } from '@material-ui/core/styles';
import withStyles, { ClassNameMap } from '@material-ui/core/styles/withStyles';
import {
  Button,
  Grid,
  TextField,
} from '@material-ui/core';
import { LoginResult as LoginResultType } from '../modules/login';
// import { LoginResult } from '../modules/login';
import { login, userinfo } from '../services/contractApi';

interface Props {
  classes: ClassNameMap;
  loginResult: LoginResultType | null;
  clearRiskJudgeMessages: () => void;
  goUpalodRiskJudgePage: () => void;
  goUploadPage: () => void;
  doRiskjudge: (id: number) => void;
  postLogin: (username: string, password: string) => void;
}

interface State {
  modalIsOpen: boolean;
  tempdoc: string;
  username: string;
  password: string;
  message: string;
  hasError: boolean;
}

const style = (theme: Theme): StyleRules => ({
  compare: {
    marginTop: theme.spacing.unit * 3,
  },
  card: {
    border: 0,
    borderRadius: 3,
    boxShadow: '0px 1px 8px 0px rgba(0,0,0,0.2)',
    padding: '0 30px',
    margin: '5px',
    paddingTop: '10px',
  },
  message: {
    color: 'red',
  },
});

class Login extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      tempdoc: 'abcd',
      username: '',
      password: '',
      message: '',
      hasError: false,
    };
    this.clickLogin = this.clickLogin.bind(this);
  }

  static defaultProps: Partial<Props> = {    // Windowsが認識できないのでコメントアウト
    // accept: [
    //   'text/plain',
    //   'application/msword',
    //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    //   'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    //   'application/vnd.ms-word.document.macroEnabled.12',
    //   'application/vnd.ms-word.template.macroEnabled.12',
    // ],
  };

  clickLogin() {
    const { goUploadPage } = this.props;
    const username = this.state.username;
    const password = this.state.password;
    login(username, password).then((res) => {
      const { status_code, access_token } = res;
      if (access_token) {
        // ログイン成功
        document.cookie = `access_token=${access_token};`;

        userinfo().then((res) => {
          const { status_code, result } = res;
          if (status_code === 401 || status_code === 403) {
            // その他エラー
            document.cookie = 'access_token=; expires=0';
            document.cookie = 'username=; expires=0';
            this.setState({ hasError: true });
            this.setState({ message: 'サーバーエラー' });
          } else {
            if (result) {
              document.cookie = `username=${result.name};`;
            }
            goUploadPage();
          }
        });
      } else if (status_code === 401) {
        // ログイン失敗
        document.cookie = 'access_token=; expires=0';
        document.cookie = 'username=; expires=0';
        this.setState({ hasError: true });
        this.setState({ message: 'IDまたはパスワードが違います' });
      }
    }).catch((err) => {
      // その他エラー
      document.cookie = 'access_token=; expires=0';
      document.cookie = 'username=; expires=0';
      this.setState({ hasError: true });
      this.setState({ message: 'サーバーエラー' });
    });
  }

  handleChangeUsernmae = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    this.setState({ username: value });
  }

  handleChangePassword = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    this.setState({ password: value });
  }

  render() {
    const { classes } = this.props;

    let emailErrorText;
    if (this.state.hasError) {
      emailErrorText = (
        <p className="contact-message-error">
          {this.state.message}
        </p>
      );
    }

    return (
      <React.Fragment>
        <Grid container justify="center" style={{ margin: '10px 0 5px' }}>
          <TextField label="ユーザ名" id="username" value={this.state.username} onChange={this.handleChangeUsernmae} />
        </Grid>
        <Grid container justify="center" style={{ margin: '10px 0 5px' }}>
          <TextField label="パスワード" type="password" id="password" value={this.state.password} onChange={this.handleChangePassword} />
        </Grid>
        <Grid container justify="center" className={classes.message}>
          {emailErrorText}
        </Grid>
        <Grid container justify="center">
        <br />
        </Grid>
        <Grid container justify="center">
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={this.clickLogin.bind(this)}
          >ログイン</Button>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(style)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.tsx